// src/components/ProtectedRoute.jsx
import { useContext, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

const ProtectedRoute = ({ children }) => {
  const { user, token, refreshUserData, logout } = useContext(AuthContext);
  const location = useLocation();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const verifyUser = async () => {
      if (!token || !user) {
        setChecking(false);
        return;
      }
      try {
        await refreshUserData(); // Refresh from backend
      } catch {
        logout(); // If token is bad, log out
      }
      setChecking(false);
    };

    verifyUser();
  }, [token, user, refreshUserData, logout]);

  if (checking) return null; // Loading state

  if (!token || !user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;
